import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import AppBar from 'material-ui/AppBar';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import './LoginStyle.css'
import {getServerHost} from '../../utils';
import {config,}  from '../../config'
import axios from 'axios';

const buildURL = (endpoint: string) => {
  const serverHost = getServerHost();
  return `${serverHost}${config.baseAPIURI}${endpoint}`;
};
type Props = {
  appContext ?:object,
  parentContext?: object

};

type State = { 
                email: string,
                password: string,
                user_name: string,
                submitButtonText: JSX.Element,
              };
class Register extends React.Component<Props, State>{
  constructor(props: any){
    super(props);
    this.state={
      user_name:'',
      email:'',
      password:'',
      submitButtonText: (<span>Submit</span>)
    }
  }
  render() {
    return (
      <div>
        <MuiThemeProvider>
          <div>
          <AppBar
             className="login-appbar" title="Register"
           />
           <br/>
           <TextField
             className="register-usr"
             hintText="panda"
             floatingLabelText="User Name"
             onChange = {(event,newValue) => this.setState({user_name:newValue})}
             />
           <br/>
           <TextField
             className="register-email"
             hintText="Enter your Email"
             type="email"
             floatingLabelText="Email"
             onChange = {(event,newValue) => this.setState({email:newValue})}
             />
           <br/>
           <TextField 
             className="register-pwd"
             type = "password"
             hintText="Enter your Password"
             floatingLabelText="Password"
             onChange = {(event,newValue) => this.setState({password:newValue})}
             />
           <br/>
           <RaisedButton className='submit-button' label={this.state.submitButtonText} primary={true} style={style} onClick={(event) => this.handleClick(event)}/>
          </div>
         </MuiThemeProvider>
      </div>
      
    );
  }
  handleClick(event: any){
    let that = this;
    let username = this.state.user_name;
    let email = this.state.email;
    let password = this.state.password;
    event.preventDefault();
    let authUrl = buildURL(`/register?username=${username}&email=${email}&password=${password}`);
    axios({
      method: 'post',
      url: authUrl,
      data: {
        username: username,
        email: email,
        password: password,
      }
    })
    .then(function (response) {
      if(response.request.status===200 && response.data.status){
        that.setState({submitButtonText: <span>Registered</span>});
        event.preventDefault();
      }
  })
    .catch(function (error) {
      console.log(error.response);
    });
}

  handleEnterClick(event: any){
    let that = this;
    if (event.keyCode === 13) {
      event.preventDefault();
      that.handleClick(event);
    }

  }}
const style = {
  margin: 15,
};
export default Register;


// WEBPACK FOOTER //
// ./src/components/Login/Register.tsx